module.exports = __webpack_public_path__ + "img/felc_cer_english.ddf11b1a.jpg";